import React, { useEffect, useState } from 'react'
import styles from './Logo.module.scss';
import logo from '../../assets/Daymap-text-logo-web.png';
import { useDiscovery, useAuth } from '../../helpers/authContext';

function Logo() {
  return (
    <div className={styles.Logo}>
      <img className={styles.Logo} src={logo} alt="Daymap Logo" />
    </div>

  )
}

export default Logo

export function SchoolLogo() {
    const { settings, clientSettings } = useAuth();
    const [logoWidth, setLogoWidth] = useState(500);

    useEffect(() => {
      var multiplier = clientSettings.zoomAmount / 100;
      setLogoWidth(500 * multiplier);
    }, [clientSettings])

    if (!settings.LogoUrl)
      return null;

    const imgUrl = `${ process.env.REACT_APP_LMS_API_ORIGIN ? process.env.REACT_APP_LMS_API_ORIGIN : '' }${settings.LogoUrl}`;

    return <img title="School Logo" className={styles.SchoolLogo} src={imgUrl} style={{ width: `${logoWidth}px`}}/>
}